import React, { useEffect, useState } from "react";
import "./css.css";
import exp1 from "../img/exp1.png";
import exp2 from "../img/exp2.png";
import tabs from "../img/tabs.png";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { db } from "../config_firebase";
import {
    collection,
    addDoc,
    getDocs,
    doc,
  } from "firebase/firestore";

/**
 * @author
 * @function Login
 *
 **/

 export const Instructions2 = (props) => {
    // const [pic, setPic] = useState(img1);
    const history = useNavigate();
    const [url, setUrl] = useState(window.location.href);
    const [userId, setUserId] = useState("");
    const [random_group, setNum] = useState("");


    useEffect(() => {
        const iosa = url.split(",");
        setUserId(iosa[1]);
      }, []);

      useEffect(() => {
        const random_group = localStorage.getItem("random_group");
        console.log(random_group);
        setNum(random_group);
      }, []);

    async function addclick(data) {
    const docRef = await addDoc(collection(db, "clicksdata"), {
        data,
    });
    }
    
//       var uniqueRandoms = [];
//       var numRandoms = 5;
//       function makeUniqueRandom() {
//       // refill the array if needed
//        if (!uniqueRandoms.length) {
//         for (var i = 0; i < numRandoms; i++) {
//             uniqueRandoms.push(i);
//         }
//     }
//     var index = Math.floor(Math.random() * uniqueRandoms.length);
//     var val = uniqueRandoms[index];

//     // now remove that value from the array
//     uniqueRandoms.splice(index, 1);

//     return val;

// }

    const next = () => {
        const guidelines_button = {
            time: Date.now(),
            userId: localStorage.getItem("user_id"),
            buttonType: "guidelines_button",
        };
        addclick(guidelines_button);
        // var numRandoms = 5;
        // var randomArray = [];
        // for (var i = 0; i < numRandoms; i++) {
        //      randomArray.push(makeUniqueRandom());
        //     }
        console.log("g", userId);
        history(`/start/?,${userId}`);
        // randomArray.shift();
        // localStorage.setItem("random_array",JSON.stringify(randomArray));
        // console.log(JSON.parse(localStorage.getItem("random_array")));
    };
    
    return(
        <div className="guideline">
            <div className="content">
                <h1>Prediction Task Guidelines</h1>
                <p>
                    <br></br>Each round of the task includes two parts:
                    <br></br> a) information and initial prediction
                    <br></br> b) recommendation and final prediction
                    <br></br><br></br>In the first part we will provide you information about each stock: charts of the stock price across the last day,
                    <br></br> last month and last year before the time point we selected, 
                    as well as financial information (details) and background information about the company (profile), <br></br>
                    as presented below:
                    <img className="example_tabs" src={tabs} alt="" />

                    <br></br>The information available to you will help you predict the price of the stock a month after the selected time point. 
                    <br></br>We will also ask you to indicate how confident you are that your prediction is correct, <br></br> as presented below:
                    <br></br><img className="examples" src={exp1} alt="" />
                </p>               
                    { random_group.includes("1") ? (
                        <p>
                            After making an initial prediction, you will receive a recommendation from a stock market expert
                            regarding the price of the stock.
                            <br></br>In earlier prediction tasks, this expert achieved a success rate of 50%. 
                        </p>
                    ) : random_group.includes("2") ? (
                        <p>
                            After making an initial prediction, you will receive a recommendation from a stock market expert
                            regarding the price of the stock.
                            <br></br>In earlier prediction tasks, this expert achieved a success rate of 90%.
                        </p>
                    ) : random_group.includes("3") ? (
                        <p>
                            After making an initial prediction, you will receive a recommendation from an AI algorithm
                            regarding the price of the stock.
                            <br></br>In earlier prediction tasks, this algorithm achieved a success rate of 50%.
                        </p>
                    ) : (
                        <p>
                            After making an initial prediction, you will receive a recommendation from an AI algorithm
                            regarding the price of the stock.
                            <br></br>In earlier prediction tasks, this algorithm achieved a success rate of 90%.
                        </p>
                    )
                }
                <p>
                    Then, you will have an opportunity to provide a final prediction of the stock price,
                    as well as indicate your confidence in your final prediction, 
                    <br></br> as presented below:
                    <br></br><img className="examples" src={exp2} alt="" />

                    <br></br><br></br> You will complete this process for all five stocks in the task.
                    <br></br>Click "Next" to proceed to the task.
                </p>
            </div>
            <div>
                <Button variant="outline-light" className="instructionsnextbutton" onClick={next}>Next</Button>
            </div>
        </div>
    );
}